import { render, staticRenderFns } from "./dbEdit.vue?vue&type=template&id=a5efeb44&"
import script from "./dbEdit.vue?vue&type=script&lang=js&"
export * from "./dbEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports